// Resets form on page load/refresh to make sure no remnant/incorrect
// data might be appearing or misleading users.
// When testing it seems that when backing up from Nets checkout
// the form would clear too soon and re-engage content, so small
// delay to help things out.
// ----------------------------------------------------------------

import $ from 'jquery';

const navigationActions = ['reload', 'back_forward'];
const currentNavigationAction = window.performance.getEntriesByType("navigation")[0] && window.performance.getEntriesByType("navigation").type;

if (currentNavigationAction !== undefined && navigationActions.includes(currentNavigationAction)) {
    var formReset = $('form.c-form');
    if (formReset.length) {
        setTimeout(function() {
            formReset[0].reset();
        }, 1000);
    }
}

// window.onSubmitDonationForm = (() => {
//   document.querySelector('#consolidated-donate-form').submit();
// });
